export const required = str => str != null && str !== undefined && str.length !== 0

export const alpha = str => str != null && str.match(/^[a-zA-Z ]+$/)

export const numeric = str => str != null && str.match(/^[0-9]+$/)

export const sameAs = (vm, key) => str => str != null && str === vm.form[key]

export const maxLength = length => str => str != null && str.length <= length

export const minLength = length => str => str != null && str.length > length

export const requiredIf = (vm, key, equal) => str => vm.form[key] === equal ? str != null && str !== undefined && str.length !== 0 : true
